import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Logo from "@/components/Logo";

export default function ChangePassword() {
  const { user, changePassword } = useAuth();
  const nav = useNavigate();
  const [cur, setCur] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  async function onSubmit(e) {
    e.preventDefault();
    setErr("");
    if (next.length < 8) {
      setErr("New password must be at least 8 characters.");
      return;
    }
    if (next !== confirm) {
      setErr("Passwords don't match.");
      return;
    }
    setBusy(true);
    try {
      await changePassword(cur, next);
      nav("/dashboard", { replace: true });
    } catch (e) {
      setErr(e.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="w-full max-w-lg">
        <div className="mb-6 flex justify-center">
          <Logo height={56} />
        </div>
        <div className="caa-card p-8">
          <h1 className="text-2xl font-bold text-[color:var(--caa-charcoal)]">
            {user?.must_change_password ? "Set a new password" : "Change password"}
          </h1>
          <p className="text-sm text-[color:var(--caa-muted)] mt-2">
            {user?.must_change_password
              ? "For security, please set a new password before continuing."
              : "Update your account password."}
          </p>

          <form onSubmit={onSubmit} className="space-y-4 mt-6" data-testid="change-password-form">
            <Field label="Current password" type="password" value={cur} onChange={setCur} testId="cp-current" />
            <Field label="New password" type="password" value={next} onChange={setNext} testId="cp-new" />
            <Field label="Confirm new password" type="password" value={confirm} onChange={setConfirm} testId="cp-confirm" />
            {err && (
              <div
                className="rounded-lg border border-[#f2c7c7] bg-[#f9eaea] px-3 py-2 text-sm text-[color:var(--caa-status-passed)]"
                data-testid="cp-error"
              >
                {err}
              </div>
            )}
            <button
              data-testid="cp-submit"
              type="submit"
              disabled={busy}
              className="w-full rounded-xl px-4 py-3 text-sm font-semibold text-white disabled:opacity-70"
              style={{ background: "var(--caa-teal-deep)" }}
            >
              {busy ? "Saving…" : "Save new password"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

function Field({ label, type, value, onChange, testId }) {
  return (
    <div>
      <label className="text-xs font-semibold text-[color:var(--caa-charcoal)] uppercase tracking-wider">
        {label}
      </label>
      <input
        data-testid={testId}
        type={type}
        required
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="mt-1 w-full rounded-xl border caa-hairline bg-white px-4 py-3 text-[15px] outline-none focus:border-[color:var(--caa-teal-deep)] focus:ring-2 focus:ring-[color:var(--caa-teal-soft)]"
      />
    </div>
  );
}
